import { useRef, useState } from "react";

export function useSearchInput() {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const onSearch = () => {
    const term = inputRef.current?.value || "";
    setSearchTerm(term);
  };

  const onClear = () => {
    setSearchTerm("");
    if (inputRef.current) {
      inputRef.current.value = "";
    }
  };

  return { inputRef, searchTerm, onSearch, onClear };
}
